import numeral from 'numeral';

export const formatNumber = (value: number): string => numeral(value).format('0,0');

export const formatShort = (value: number): string => {
  if (Math.abs(value) < 100) {
    if (value % 1 === 0) {
      return numeral(value).format('0');
    } else {
      return numeral(value).format('0.00');
    }
  }

  if (Math.abs(value) < 1000) {
    return numeral(value).format('0');
  }

  if (value % 1000 === 0) {
    return numeral(value).format('0a');
  }

  return numeral(value).format('0.[0]a');
};

export const formatPopulation = (value: number, suffixColor: string = 'metal-400'): string => {
  const absValue = Math.abs(value);
  
  // Below 1 million: show number as-is
  if (absValue < 1000000) {
    return numeral(value).format('0,0');
  }
  
  // Below 1 billion: show with M (million)
  if (absValue < 1000000000) {
    const formatted = numeral(value / 1000000).format('0.[0]');
    return `${formatted} <span class="text-${suffixColor}">M</span>`;
  }
  
  // Below 1 trillion: show with B (billion)
  if (absValue < 1000000000000) {
    const formatted = numeral(value / 1000000000).format('0.[0]');
    return `${formatted} <span class="text-${suffixColor}">B</span>`;
  }
  
  // 1 trillion and up: show with T (trillion)
  const formatted = numeral(value / 1000000000000).format('0.[0]');
  return `${formatted} <span class="text-${suffixColor}">T</span>`;
};
